import {burgerMenuClose} from './burger';

export default function () {
    const headerElement = document.querySelector('#header');
    const observerPixelElement = document.querySelector('#observer-pixel');
    const headerContactLauncherElement = document.querySelector('#header-contact-launcher');
    const inlineContactLauncherElements = document.querySelectorAll('button[data-launcher="contact"]');
    const inlineContactFormElement = document.querySelector('#room-contact');
    const burgerElement = document.querySelector('#burger-input');
    const anchoredElements = document.querySelectorAll('[data-anchor]');
    const contactOpenEvent = new Event('contactOpen');

    if (headerContactLauncherElement) {
        headerContactLauncherElement.addEventListener('click', (e) => {
            if (inlineContactFormElement) {
                inlineContactFormElement.scrollIntoView({behavior: 'smooth', block: 'start'});
            } else {
                window.dispatchEvent(contactOpenEvent);
            }
        });
    }

    if (inlineContactLauncherElements) {
        inlineContactLauncherElements.forEach((element) => {
            element.addEventListener('click', () => {
                if (inlineContactFormElement) {
                    inlineContactFormElement.scrollIntoView({behavior: 'smooth', block: 'start'});
                } else {
                    window.dispatchEvent(contactOpenEvent);
                }
            });
        });
    }

    anchoredElements.forEach(element => {
        element.addEventListener('click', e => {
            const isSamePath = isTargetOnSamePath(e.currentTarget.dataset.path);
            const target = document.querySelector(e.currentTarget.dataset.anchor);
            if (target && isSamePath) {
                e.preventDefault();

                // it's important to close burger first and only then start scrolling to element
                burgerMenuClose(burgerElement);

                window.history.replaceState(null, '', `${e.currentTarget.dataset.anchor}`);

                // no safely scroll to element
                setTimeout(() => {
                    target.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 100);
            }
        });
    });

    if (headerElement && observerPixelElement) {
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(elements => {
                headerElement.classList.toggle('compact', elements[0].intersectionRatio === 0);
            });

            observer.observe(observerPixelElement);
        }
    }
}

/**
 * Check if JS scroll to link is on same path, defaults to true as there might be elements
 * that link to any page they're on ex. "KONTAKT" button in the header
 * @param path
 * @returns {boolean}
 */
function isTargetOnSamePath(path) {
    const hasPathSet = path !== (void 0);
    if (hasPathSet) {
        return window.location.pathname === path;
    }

    return true;
}
